import { makeStyles } from '@material-ui/core';

import { inputErrorBorder } from '@/styles/inputStyles.ts';

export const useDateFieldQuestionStyles = makeStyles(() => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
    },
    textfield: {
        height: '3.75rem',
    },
    error: {
        ...inputErrorBorder,
    },
    requiredLabel: {
        '& .MuiFormLabel-asterisk': {
            color: '#D32F2F',
            fontSize: '1.2em',
        },
    },
    errorText: {
        fontSize: '0.875rem',
        textTransform: 'none',
        lineHeight: '1.5rem',
        color: '#da3030',
        marginTop: '0.5rem',
    },
}));

export const useDropdownQuestionStyles = makeStyles(() => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
    },
    textfield: {
        height: '3.75rem',
    },
    error: {
        ...inputErrorBorder,
    },
    requiredLabel: {
        '& .MuiFormLabel-asterisk': {
            color: '#D32F2F',
            fontSize: '1.2em',
        },
    },
    errorText: {
        fontSize: '0.875rem',
        textTransform: 'none',
        lineHeight: '1.5rem',
        color: '#da3030',
        marginTop: '0.5rem',
    },
}));

export const useListQuestionStyles = makeStyles((theme) => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
        marginBottom: '1rem',
    },
    graySection: {
        marginTop: 20,
        padding: 20,
        backgroundColor: theme.palette.common.lightBrown,
        borderRadius: theme.radius.default,
    },
    questionsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    flexClass: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 10,
        [theme.breakpoints.down('sm')]: {
            alignItems: 'baseline',
        },
    },
    subHeading: {
        fontSize: 16,
        color: theme.palette.common.black,
    },
    flexImg: {
        display: 'flex',
    },
    pointer: {
        cursor: 'pointer',
    },
    placeholderContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem 0',
    },
}));

export const useMultiSelectQuestionStyles = makeStyles(() => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
        marginBottom: '1rem',
    },
    optionsContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 20,
    },
    switchOptionsContainer: {
        flexDirection: 'column',
    },
    btnContentText: {
        textTransform: 'none',
        fontSize: 16,
    },
    optionSwitch: {
        margin: '0 5px 0 0',
    },
    switchContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'center',
    },
}));

export const useNewRadioQuestionStyles = makeStyles(() => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
    },
    answersWrapper: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 20,
        marginTop: '1rem',
    },
    answerOption: {
        flex: ({ matches }) => matches && '1 0 45%',
        paddingInline: ({ matches }) => matches && 2,
        textAlign: 'center',
    },
    answerOptionLabel: {
        wordWrap: 'break-word',
    },
}));

export const useNumberFieldQuestionStyles = makeStyles(() => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
    },
    textfield: {
        height: '3.75rem',
    },
    error: {
        ...inputErrorBorder,
    },
    requiredLabel: {
        '& .MuiFormLabel-asterisk': {
            color: '#D32F2F',
            fontSize: '1.2em',
        },
    },
    errorText: {
        fontSize: '0.875rem',
        textTransform: 'none',
        lineHeight: '1.5rem',
        color: '#da3030',
        marginTop: '0.5rem',
    },
}));

export const useRadioQuestionStyles = makeStyles(() => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
    },
}));

export const useTextAreaQuestionStyles = makeStyles((theme) => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
    },
    inputLabel: {
        '&.focused': {
            color: theme.palette.common.darkGrey,
        },
        '&.shrink': {
            fontSize: '1rem',
        },
    },
    fieldFocused: {
        backgroundColor: 'white',
        border: `2px solid ${theme.palette.common.yellow} !important`,
    },
    filledInputRoot: {
        overflow: 'hidden',
        backgroundColor: 'white',
        border: '1px solid #ABABAB',
        paddingRight: 10,
        borderRadius: theme.radius.default,
        fontSize: '1rem',
        height: '100%',
        '&:hover': {
            backgroundColor: '#F9F8F4',
        },
    },
}));

export const useTextFieldQuestionStyles = makeStyles(() => ({
    title: {
        fontSize: 18,
        fontWeight: 'normal',
    },
    error: {
        ...inputErrorBorder,
    },
    errorText: {
        fontSize: '0.875rem',
        textTransform: 'none',
        lineHeight: '1.5rem',
        color: '#da3030',
        marginTop: '0.5rem',
    },
    requiredLabel: {
        '& .MuiFormLabel-asterisk': {
            color: '#D32F2F',
            fontSize: '1.2em',
        },
    },
}));
